import axios from 'axios';

export enum PromptType {
    SYSTEM = 'SYSTEM',
    USER = 'USER',
}

export interface Prompt {
    id: number;
    type: PromptType;
    content: string;
}

export const getPrompt = async (type: PromptType, currentLanguage: string): Promise<Prompt> => {
    const response = await axios.get<Prompt>(`/prompts/${type}`, {
        params: {
            lang: currentLanguage
        }
    });
    return response.data;
};

export const updatePrompt = async (type: PromptType, content: string, currentLanguage: string): Promise<void> => {
    await axios.put(`/prompts/${type}`, content, {
        headers: {
            'Content-Type': 'text/plain',
        },
        params: {
            lang: currentLanguage,
        },
    });
};
